import {HttpInterceptorFn} from '@angular/common/http';
import {AuthService} from '../../../features/auth/services/auth/auth.service';
import {inject} from '@angular/core';
import {jwtDecode, JwtPayload} from 'jwt-decode';
import {ToastrService} from 'ngx-toastr';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const _authService: AuthService = inject(AuthService);
  const _toastrService: ToastrService = inject(ToastrService);

  const accessToken: string = _authService.accessToken();

  if (accessToken) {
    const decodedToken: JwtPayload = jwtDecode(accessToken);
    const isTokenExpired: boolean = decodedToken && decodedToken.exp ? decodedToken.exp < Date.now() / 1000 : false;
    if (isTokenExpired) {
      _authService.logout();
      _toastrService.error('Session Expired', 'Authentication Failed');
    } else {
      const clonedRequest = req.clone({setHeaders: {Authorization: `Bearer ${accessToken}`}});
      return next(clonedRequest);
    }

  }
  return next(req);
};
